
import { Options, Vue } from "vue-class-component";

@Options({
  watch: {
    '$route.name': function (newVal:any, oldVal:any) {
      if (newVal !== oldVal) {
       this.activeName = newVal
      }
    },
  },
})
export default class PcTabsBar extends Vue {
  private activeName: string = "Pagelist";

  created(): void {
  }
  getTabVal(item:any){
    this.$router.push({ name: item.props.name });
  }
}
